import { render, staticRenderFns } from "./TextSlotControls.vue?vue&type=template&id=4af22c5c&scoped=true&"
import script from "./TextSlotControls.vue?vue&type=script&lang=ts&"
export * from "./TextSlotControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af22c5c",
  null
  
)

export default component.exports